/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesPriceListCreateDto } from '../../models/sales-price-list-create-dto';
import { SalesPriceListResponseDto } from '../../models/sales-price-list-response-dto';

export interface PriceListsControllerCreate$Params {

/**
 * The tenant identifier.
 */
  tenant: string;
      body: SalesPriceListCreateDto
}

export function priceListsControllerCreate(http: HttpClient, rootUrl: string, params: PriceListsControllerCreate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesPriceListResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, priceListsControllerCreate.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesPriceListResponseDto>;
    })
  );
}

priceListsControllerCreate.PATH = '/o2-sales/price-lists/{tenant}';
